@if (tilesGroup?.tiles?.length > 1) {
  <div class="wc-spy-target" [sdSpyTarget]="componentUid"></div>
  <wc-wrapper [contentWrapper]="wrapper">
    <sd-tiles-group sd-component-wrapper-component
      [tilesGroup]="tilesGroup"
      [tileTitleLevel]="titleLevelTilesGroup"
      [position]="position"
      [layout]="layout"
      [context]="context"
      [twicPicsAutoSize]="!isFirst"
    />
  </wc-wrapper>
}
